import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './KnowYourRights.css';
import { LanguageContext } from '../App';
import { useAuth } from '../context/AuthContext';
import { translations } from '../utils/translations';

function AccordionItem({ section }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <button
        className={`accordion-header ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="accordion-icon">{section.icon}</span>
        <span className="accordion-title">{section.title}</span>
        <span className="accordion-toggle">{isOpen ? '−' : '+'}</span>
      </button>
      {isOpen && (
        <div className="accordion-content">
          <ul className="rights-list">
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function PublicStop() {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  const t = translations[language] || translations.en;
  const { user, intakeComplete } = useAuth();
  const SECTIONS = [
    {
      id: 1,
      title: t.accordion.shared.whatToDoImmediately,
      icon: '1',
      items: t.accordion.public.sections.what,
    },
    {
      id: 2,
      title: t.accordion.shared.yourLegalRights,
      icon: '2',
      items: t.accordion.public.sections.rights,
    },
    {
      id: 3,
      title: t.accordion.shared.whatToSay,
      icon: '3',
      items: t.accordion.public.sections.say,
    },
    {
      id: 4,
      title: t.accordion.shared.whatNotToDo,
      icon: '4',
      items: t.accordion.public.sections.not,
    },
  ];

  useEffect(() => {
    if (!user) {
      navigate('/register');
      return;
    }

    if (!intakeComplete) {
      navigate('/intake');
    }
  }, [user, intakeComplete, navigate]);

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="rights-section">
          <button className="back-button" onClick={() => navigate('/dashboard')}>
            {t.accordion.public.back}
          </button>
          <h2>{t.accordion.public.title}</h2>
          <p className="rights-intro">{t.accordion.public.intro}</p>

          <div className="accordions-container">
            {SECTIONS.map((section) => (
              <AccordionItem key={section.id} section={section} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PublicStop;
